import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import axios from 'axios';
import AccordionDisplay from './AccordionDisplay';
import NavBarDiv from './NavBar';
import Card from '../Card/Card';
import Swal from 'sweetalert2';

var PurchaseInvoiceData = [];

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

function wait(time) {
  return new Promise(resolve => setTimeout(resolve, time))
}

const ReceivedInvoicesPage = () => {
  const [, setDataInv] = useState('');

  useEffect(() => {
    let isMounted = true;
    PurchaseInvoiceData = []
    const payload = {
      direction: 'Purchase'
    }
    const doMagic = async () => {
      await wait(500)
      const getData = async () => {
        let dataFromApi = []
        await axios.post(`/api/invoices/getIds/`, payload)
          .then(data => {
            dataFromApi = data.data
          })
          .catch(error => {
            Toast.fire({
              icon: 'error',
              title: error.response.data.error
            })
          })
        return dataFromApi
      };
      const getInvoiceData = async (dataIds) => {
        if (dataIds) {
          for (const id of dataIds) {
            if(isMounted === false){ break; }
            await wait(500)
            await axios.post(`/api/invoices/getXmlData/${id}`, payload)
              .then(data => {
                PurchaseInvoiceData.push(data.data[0]);
                setDataInv({}, [])
              })
              .catch(err => {
                console.log(err)
              })
          }
        } else {
          console.log('greska')
        }
        return null;
      }
      await getData()
        .then(async res => {
          await getInvoiceData(res)
        })
        .catch(console.error)
    }

    doMagic();

    return () => {
      isMounted = false;
    }

  }, [])

  return (
    <div className="content">
      <Row>
        <Card title='Nabavne fakture' />
        < AccordionDisplay dataSet={PurchaseInvoiceData} />
      </Row>
      <NavBarDiv />
    </div>
  );
}

export default ReceivedInvoicesPage;
